import { trigger_date_picker, start_loading, end_loading } from './../function/common.js';
import { notification } from './../function/notification.js';

document.addEventListener("DOMContentLoaded", function() {
	const pathname = window.location.pathname;
	const path_array = pathname.split('/');
	
	//ADMIN Listeners
	if(path_array[1] === 'a'){
		
		
		//Update a Published Trip after Review
		$('body').on('click', '.admin_action', async function(e){
			e.preventDefault();
			
			let trip_id = $(this).closest('tr').attr('data-trip');
			let action = $(this).hasClass('admin_action--confirm') ? 'approved' : 'rejected';
			let review_form = new FormData();
			review_form.append('trip_id', trip_id);
			review_form.append('action', action);
			
			try {
				let response = await fetch('/api/admin/review', {
					method: 'POST',
					body: review_form
				});

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				let result = await response.json();
				
				if(result.error){
					//error
				}else{
					$(`tr[data-trip="${trip_id}"]`).fadeOut(400, function() {
						$(`tr[data-trip="${trip_id}"]`).remove();
					});
				}
				
			} catch (error) {
				console.error('Error ***', error);
			}
		});
		
		//Create a new content entry
		$('body').on('click', '.admin_content--add', async function(e){
			e.preventDefault();
			
			$('#admin_content').css("display", "flex").hide().fadeIn(200);
		});
		
		//Create "public" on a content entry
		$('body').on('change', '.admin_content--public', async function(e){
			e.preventDefault();
			
			let content_id = $(this).closest('tr').attr('data-content');
			let action = $(this).is(':checked') ? '1' : '0';
			let public_form = new FormData();
			public_form.append('content_id', content_id);
			public_form.append('public', action);
			
			try {
				start_loading('Processing...');
				let response = await fetch('/api/content/public', {
					method: 'POST',
					body: public_form
				});

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				let result = await response.json();
				
				if(result.error){
					end_loading('Error');
				}else{
					end_loading('Success');
				}
				
			} catch (error) {
				console.error('Error ***', error);
			}
		});
		
		//Delete a content
		$('body').on('click', '.admin_content--delete', async function(e){
			e.preventDefault();
			
			alert('Let Josh know you want to delete this');
		});
	}
});